import React from 'react';
import NumberTypePage from './NumberTypePage';

const MobileNumbers = () => <NumberTypePage type="mobile" />;

export default MobileNumbers;
